import type { RouteObject } from 'react-router-dom';
import { SettingsTeamsPage } from '~/pages/settings';
import { Action, Resource } from '~/api/graphql';
import { ProtectedRoute } from '~/components/permissions';

export const teamsRoute: RouteObject = {
  path: 'teams',
  element: (
    <ProtectedRoute
      permissions={[{ resource: Resource.Team, action: Action.List }]}
      redirectTo="/app/settings/profile"
    >
      <SettingsTeamsPage />
    </ProtectedRoute>
  )
};
